import { Request } from './Request';

export class CancelPendingInviteRequest extends Request {
  method = 'DELETE';
  url = '/tc/tmemberinvite';

  constructor(inviteId: number | undefined) {
    super();

    this.url = '/tc/tmemberinvite?invite_id=' + inviteId;
  }
}
